import React from "react";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { DashboardShell } from "../../components/shared/DashboardShell";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { LoadingState } from "../../components/shared/EmptyState";
import { LocationCard } from "../../components/student/LocationCard";
import { studentNav } from "../../components/shared/navConfig";
import { useApi } from "../../lib/useApi";

const KYC = { approved: "Verified", pending: "Pending", rejected: "Rejected", not_started: "Pending" };

const Row = ({ l, v }) => (
  <div className="flex items-start justify-between gap-4 py-2.5 border-b last:border-b-0 text-sm" style={{ borderColor: "var(--border)" }}>
    <span className="text-xs shrink-0" style={{ color: "var(--text-dim)" }}>{l}</span>
    <span className="text-right break-words min-w-0" style={{ color: "var(--text)" }}>{v || "—"}</span>
  </div>
);

export default function StudentProfile() {
  const { data, loading, reload } = useApi("/profile/me");
  const u = data?.user || {};
  const p = data?.profile || {};
  return (
    <DashboardShell nav={studentNav} title="My profile" subtitle="Your details as seen by the admin team">
      {loading ? <LoadingState/> : (
        <div className="grid lg:grid-cols-2 gap-5">
          <div className="card-surface p-4 sm:p-5">
            <div className="flex items-center justify-between mb-3 gap-3">
              <div className="min-w-0">
                <div data-testid="profile-name" className="font-display text-lg truncate" style={{ color: "var(--text)" }}>{p.name || u.name}</div>
                <div className="text-xs truncate" style={{ color: "var(--text-dim)" }}>{u.email}</div>
              </div>
              <StatusBadge status={KYC[u.kyc_status || "not_started"]} testId="profile-kyc-badge"/>
            </div>
            <Row l="Mobile" v={p.mobile}/>
            <Row l="City" v={p.city}/>
            <Row l="PIN code" v={p.pin}/>
            <Row l="College" v={p.college}/>
            <Row l="Degree / Course" v={[p.degree, p.course].filter(Boolean).join(" · ")}/>
            <Row l="Year" v={p.year}/>
            <Row l="Skills" v={(p.skills || []).join(", ")}/>
            <Link to="/student/onboarding" data-testid="edit-profile-btn" className="btn-ghost mt-4 w-full py-2.5 rounded-full text-xs inline-flex items-center justify-center gap-1.5"><Pencil size={12}/> Edit profile & KYC</Link>
          </div>
          <LocationCard profile={p} onSaved={reload}/>
        </div>
      )}
    </DashboardShell>
  );
}
